import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
const reasons = ["We show up when we say we will — no 4-hour windows, no 'we'll be there soon'", 'We bring the right equipment — no improvising, no cutting corners', 'We clean up completely — branches, debris, everything goes', "We handle emergencies fast — because we know a tree down can't wait", 'Years of experience and professional equipment — your property is in safe hands', 'We serve all of Orange County — wherever you are, we come to you'];
export const WhyChooseUs = () => {
  return <section id="why-us" className="py-24 bg-white" data-id="element-354">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-355">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-356">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-357">
            <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-6 leading-tight" data-id="element-358">
              Why Orange County Homeowners Choose South Coast Tree Care
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-359">
              We're not a national chain. We're not a crew you found on
              Craigslist.
            </p>
            <p className="text-lg text-gray-700 font-medium mb-10 p-6 bg-earth/10 border-l-4 border-earth rounded-r-xl" data-id="element-360">
              We're a local team that shows up on time, does the job right, and
              treats your property like it's our own.
            </p>
            <p className="font-bold text-charcoal text-xl mb-6" data-id="element-361">
              Here's what that means in practice:
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-4" data-id="element-362">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-offwhite p-5 rounded-xl border border-gray-100" data-id="element-363">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-forest text-white flex items-center justify-center mt-0.5" data-id="element-364">
                  <CheckIcon className="w-5 h-5" data-id="element-365" />
                </div>
                <p className="text-gray-800 font-medium leading-relaxed" data-id="element-366">
                  {reason}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
};